'use client';
import React from 'react';
import { useWatch } from "react-hook-form";
import useMioForm from "../shared/useMioForm.jsx"
import Wrapper from "../shared/Wrapper.jsx"

function MioNumber(p) {
    const { mioID, field, isDirty, isInvalid, isTouched } = useMioForm(p.name, p.required);
    const formValue = useWatch({ name: p.name });
    const onChange = (event) => {
        let value = event.target.value;
        if (value) {
            value = value.toString().replace(',', '.');
        }
        field.onChange(value);
    }
    const onBlur = (event) => {
        let value = formValue;
        if (value) {
            value = parseFloat(value);
            if (isNaN(value)) value = null;
        }
        field.onChange(value);
        field.onBlur(event);
    }
    return (
        <Wrapper {...p} mioID={mioID} isInvalid={isInvalid} isTouched={isTouched} isDirty={isDirty}>
            <div className="mtwi">
                <input
                    className={`
                        mio-form-control-input
                        ${p.tabular && 'tabular'}
                        ${isInvalid ? 'mio-form-control-input-invalid ' : ''}
                        `}
                    id={mioID}
                    placeholder={p.placeholder}
                    autoComplete="off"
                    type="text"
                    inputMode="decimal" pattern="^\d*\.?\d*$"
                    {...field}
                    value={field.value ?? ''}
                    onChange={onChange}
                    onBlur={onBlur}
                ></input>
            </div>
        </Wrapper >
    )
}
export default MioNumber
{/* {isDirty ? 'dirty' : 'not-dirty'} |
            {isInvalid ? 'invalid' : 'not-invalid'} |
            {isTouched ? 'touched' : 'not-touched'} */}